import React, { useEffect, useState } from 'react';
import { Flex, Image, Text, Heading, Menu, MenuButton, MenuList, MenuItem, Button } from '@chakra-ui/react';
import { Link as CLink } from '@chakra-ui/react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

import logo from '../../Resources/Images/Logos/logo.svg';
import logo_eng from '../../Resources/Images/Logos/english_logo.svg';
import logo_dev from '../../Resources/Images/Logos/logo_dev.svg';
import logo_eng_dev from '../../Resources/Images/Logos/english_logo_dev.svg';

import Burger from './Burger';
import useMedia from '../../Utils/useMedia';

const Navbar: React.FC = () => {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const [isChinese, setIsChinese] = useState<boolean>(i18n.language === 'zh');
  const { isMobile, isDesktop, isTablet } = useMedia();
  const navLinks1 = [
    { path: '/about', text: t('navbar.about') },
    { path: '/upload', text: t('navbar.verification') },
    { path: '/news', text: t('navbar.news') },
  ];
  const navLinks2 = [
    { path: '/school', text: t('navbar.issuanceUnits') },
  ];

  const checkLetterSpacing = () => {
    const elements = Array.from(document.getElementsByTagName('p'));
    elements.forEach((el) => {
      el.style.letterSpacing = isChinese ? '1px' : '0.5px';
    })
    const anchors = Array.from(document.getElementsByTagName('a'));
    anchors.forEach((el) => {
      el.style.letterSpacing = isChinese ? '1px' : '0.5px';
    })
    const labels = Array.from(document.getElementsByTagName('label'));
    labels.forEach((el) => {
      el.style.letterSpacing = isChinese ? '1px' : '0.5px';
    })
    const buttons = Array.from(document.getElementsByTagName('button'));
    buttons.forEach((el) => {
      el.style.letterSpacing = isChinese ? '1px' : '0.5px';
    })
  };
  const toggleLang = () => {
    if (isChinese) {
      i18n.changeLanguage('en');
    } else {
      i18n.changeLanguage('zh');
    }
    setIsChinese(!isChinese);
  };

  const dropDownMenu = () => {
    return (
      <Menu>
        <MenuButton as={CLink} to="#" _hover={{ fontWeight: 600 }} mr="32px">{t('navbar.FAQ')}</MenuButton>
        <MenuList>
          <MenuItem as={Link} to="/FAQ1" fontWeight={450}>{t('certCategory.degreeCertificate')}</MenuItem>
          <MenuItem as={Link} to="/FAQ2" fontWeight={450}>{t('certCategory.teacherCertificate')}</MenuItem>
          <MenuItem as={Link} to="/FAQ3" fontWeight={450}>{t('certCategory.langCertificate')}</MenuItem>
          <MenuItem as={Text} to="/FAQ3#tocfl" pl="40px"><a href="/FAQ3#tocfl">{t('certCategory.tocfl')}</a></MenuItem>
          <MenuItem as={Text} to="/FAQ3#tlpt" pl="40px"><a href="/FAQ3#tlpt">{t('certCategory.tlpt')}</a></MenuItem>
          <MenuItem as={Text} to="/FAQ3#bestep" pl="40px"><a href="/FAQ3#bestep">{t('certCategory.bestep')}</a></MenuItem>
          <MenuItem as={Link} to="/FAQ4" fontWeight={450}>{t('certCategory.creditCertificate')}</MenuItem>
          <MenuItem as={Text} to="/FAQ4#tbua" pl="40px"><a href="/FAQ4#tbua">{t('certCategory.tbua')}</a></MenuItem>
          <MenuItem as={Text} to="/FAQ4#taica" pl="40px"><a href="/FAQ4#taica">{t('certCategory.taica')}</a></MenuItem>
          <MenuItem as={Link} to="/FAQ5" fontWeight={450}>{t('certCategory.professionalCertificate')}</MenuItem>
          <MenuItem as={Text} to="/FAQ5#pfep" pl="40px"><a href="/FAQ5#pfep">{t('certCategory.pfep')}</a></MenuItem>
          <MenuItem as={Text} to="/FAQ5#pslp" pl="40px"><a href="/FAQ5#pslp">{t('certCategory.pslp')}</a></MenuItem>
        </MenuList>
      </Menu>
    );
  }

  useEffect(() => {
    checkLetterSpacing();
  }, [location.pathname, isChinese]);

  return (
    <>
    <Burger />
    <Flex as='header' position='sticky' top='0' w='100%' h='64px' p='0 10px'
      justify='space-between' alignItems='center' zIndex='999'
      borderBottom='1px solid' borderColor='grey.light' backgroundColor='#fff'
    >
      <Heading as='h1' variant='lg_normal'>
        <NavLink exact to={'/upload'}>
          <Flex align='center'>
            <Image h='36px' cursor='pointer'
              alt='教育部電子學位證書驗證平台上傳頁面'
              src={i18n.language === 'zh' ?
                ((window as any).env.BETA ? logo_dev : logo) :
                ((window as any).env.BETA ? logo_eng_dev : logo_eng)}
            />
            <Text display='none'>教育部電子學位證書驗證平台</Text>
          </Flex>
        </NavLink>
      </Heading>
      <Flex as='nav' textStyle='normal_md' textAlign='center' alignItems={'center'}>
        <a href="#U" title="右上方功能區塊" id="AU" accessKey="U" style={{marginRight:'16px'}}>:::</a>
        {isDesktop && navLinks1.filter(link => link.text !== '').map((link, index) => (
          <NavLink exact to={link.path} key={index}>
            <Text mr='32px' _hover={{ fontWeight: 600 }}>{link.text}</Text>
          </NavLink>
        ))}
        {isDesktop && dropDownMenu()}
        {isDesktop && navLinks2.filter(link => link.text !== '').map((link, index) => (
          <NavLink exact to={link.path} key={index}>
            <Text mr='32px' _hover={{ fontWeight: 600 }}>{link.text}</Text>
          </NavLink>
        ))}
        {isChinese
          ? <CLink href='#' height={'fit-content'} textStyle='normal_md' onClick={toggleLang}>EN</CLink>
          : <CLink href='#' height={'fit-content'} textStyle='normal_md' onClick={toggleLang}>中文</CLink>
        }
        &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      </Flex>
    </Flex>
    </>
  )
}

export default Navbar;
